// business jobs
export const businessJobs = ["Rhoads", "Engine Room", "RFH", "Intentionally", "Intentionaly", "NL", "Email", "GridBright", "Research", "Immerge Quotes", "Immerge", "Blink", "Canal Convergence ‘22", "Canal Convergence ‘24", "AESG", "Exelon", "Fingerpaint", "OCTC", "LISI", "Scribewise", "AC/DC", "Photography", "Simplified Marketing", "Sewer Authority", "Business"];

export const jobCategories = [
	{
		title: "Business",
		jobs: ["Business", "Email"],
		total: 0,
		tasks: "Accounting, scheduling, office, cleaning",
	},
	{
		title: "NL",
		jobs: ["NL"],
		total: 0,
		tasks: "Dev sales, business specific tasks, invoices",
	},
	{
		title: "Immerge",
		jobs: ["Immerge Quotes", "Immerge", "prince quote"],
		total: 0,
		tasks: "sketches, proposals, rfqs, installation sales",
	},
	{
		title: "Immerge Projects",
		jobs: ["Canal Convergence ‘22", "Canal Convergence ‘24", "Blink", "Canal Convergence 2020", "Miss WCU", "Miss Phila", "Insiders", "ANTSO", "Genetic", "Miss WCU", "Miss Philly", "Miss DE", "OCTC", "Doc Swan", "La Costa", "Doc Swan", "La Costa", "Sparks Entertainment", "Singin' in the Rain"],
		total: 0,
	},
	{
		title: "Research",
		jobs: ["Research", "New"],
		total: 0,
		tasks: "general inquiry calls about future strategy, reading, researching comps",
	},
	{
		title: "Clients",
		jobs: ["Rhoads", "Engine Room", "GridBright", "AESG", "Exelon", "Fingerpaint", "LISI", "Scribewise", "AC/DC", "Simplified Marketing", "Sewer Authority", "Salon Moxi", "SEP", "Great Dehne Productions", "Remesh", "DMW", "d4 Creative", "TME", "Razorfish Health", "RFH", "Intentionally", "Intentionaly", "FPM", "Sebastian Copeland", "Master Foods", "Master Foods", "Sebastian Copeland", "Real Estate", "Roland", "Media Tree", "Moxi", "Wildlife"],
		total: 0,
	},
	{
		title: "Home",
		jobs: ["Home", "Mob Med", "Pup Time", "Fitness"],
		total: 0,
	},
	{
		title: "Wedding",
		jobs: ["Wedding"],
		total: 0,
	},

	{
		title: "Photography",
		jobs: ["Photography"],
		total: 0,
	},
	{
		title: "Mob Med",
		jobs: ["Mob Med"],
		total: 0,
	},
	{
		title: "Pup Time",
		jobs: ["Pup Time"],
		total: 0,
	},
	{
		title: "Fitness",
		jobs: ["Fitness"],
		total: 0,
	},
	{
		title: "Home_",
		jobs: ["Home"],
		total: 0,
	},

	{
		title: "Bed",
		jobs: ["Bed"],
		total: 0,
	},
];

export const businessChart = ["Business", "NL", "Immerge", "Immerge Projects", "Clients", "Photography", "Research", "Canal Convergence ‘24", "Wildlife"];

export const yearChart = ["Business", "NL", "Immerge", "Immerge Projects", "Clients", "Photography", "Research", "Wedding", "Mob Med", "Pup Time", "Fitness", "Home_", "Bed"];

export const yearChartSubs = ["Business", "NL", "Immerge", "Immerge Projects", "Clients", "Photography", "Research", "Wedding", "Mob Med", "Pup Time", "Fitness"];

// BUSINESS GENERAL, NL BUSINESS, IMMERGE GENERAL, IMMERGE PROJECTS, CLIENTS

// BILLABLE, NON-BILLABLE, HOBBY, FITNESS, MEDIATE, HOME, BED

export const dayStartsAt = 6; //6
export const hoursInADay = 18; //18

export const accounts = [
	{ account: "NL: Chase - Sapphire Preferred", name: "Sapphire Preferred", group: "NL Credit" },
	{ account: "NL: Chase - United Explorer", name: "United Explorer", group: "NL Credit" },
	{ account: "NL: Chase - Freedom", name: "Freedom", group: "NL Credit" },
	{ account: "NL: Home - CL", name: "CL", group: "NL Credit" },

	{ account: "NL: Checking - D100", name: "Checking", group: "NL Accounts" },
	{ account: "NL: Cash", name: "Cash", group: "NL Accounts" },
	{ account: "NL: Home Saving - S000", name: "Savings", group: "NL Accounts" },

	{ account: "Erin: Chase - Sapphire Preferred", name: "Sapphire Preferred", group: "Erin Accounts" },
	{ account: "Erin: PNC - Points Credit Card", name: "Points CC", group: "Erin Accounts" },
	{ account: "Erin: PNC - CashBack Credit Card", name: "CashBack CC", group: "Erin Accounts" },
	{ account: "Erin: PNC - Checking", name: "Checking", group: "Erin Accounts" },
	{ account: "Erin: PNC - Savings", name: "Savings", group: "Erin Accounts" },

	{ account: "NL: Immerge Checking", name: "Checking", group: "Immerge" },
	{ account: "NL: Immerge Saving", name: "Savings", group: "Immerge" },
	{ account: "NL: Chase - Ink Bold Preferred", name: "Ink Bold Preferred", group: "Immerge" },
	{ account: "NL: Chase - United Business", name: "United Business", group: "Immerge" },

	{ account: "NL: COIN", name: "Crypto", group: "Investments" },
	{ account: "NL: VAN", name: "Stocks", group: "Investments" },

	{ account: "Erin: 401k", name: "Erin 401k", group: "Retirement" },
	{ account: "NL: IRA", name: "NL IRA", group: "Retirement" },

	{ account: "NL: Capital One - Money Market", name: "Capital One", group: "Inactive" },
	{ account: "NL: Capital One - 3M", name: "Capital One", group: "Inactive" },
	{ account: "NL: Capital One - Tax Savings", name: "Capital One", group: "Inactive" },
	{ account: "NL: Checking - D101", name: "D101", group: "Inactive" },
	{ account: "NL: Home Saving - S007", name: "S007", group: "Inactive" },
	{ account: "NL: Tax Estimate", name: "Tax Estimate", group: "Inactive" },
];
